var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SkipTo'),_c('Menu'),_c('main',{attrs:{"id":"main","tabindex":"-1"}},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }